export default __webpack_public_path__ + "static/media/notif_new_request.35119b78.svg";